import dayjs from "dayjs";
import EditorViewer from "../../../../../components/EditorViewer";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDeleteFaqById } from "../../../../../api/inquiries/faq/use-faq";
import { useFAQById } from "../../../../../api/inquiries/faq/use-faq-detail";
import TitlePage from "../../../../../components/section/TitlePage/Titlepage";
import Button from "../../../../../components/ui/Button/Button";
import Modal from "../../../../../components/ui/Modal/Modal";

const FAQDetailPage = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { data } = useFAQById(id);
  const { mutate: deleteFAQById } = useDeleteFaqById();
  const faqData = data?.data;
  const handleBack = () => {
    navigate("/bulletin-board");
  };

  const handleEdit = () => {
    navigate("edit");
  };

  const onDeleteEvent = async () => {
    await deleteFAQById(id);
  };

  return (
    <>
      <div>
        <TitlePage title="FAQ > FAQ 상세" />
        <div className="mt-4">
          <div className="flex items-center">
            <div className="w-1/2">
              <div className="flex w-full">
                <div className="text-[12px] border border-r-0 text-black border-primary-grey bg-input-grey p-2 w-[150px]">
                  분류
                </div>
                <div className="p-2 border grow">
                  {" "}
                  {faqData?.faqCategory?.name}
                </div>
              </div>
            </div>
            <div className="w-1/2">
              <div className="flex w-full">
                <div className="text-[12px] border border-r-0 text-black border-primary-grey bg-input-grey p-2 w-[150px]">
                  등록일시
                </div>
                <div className="p-2 border grow">
                  {dayjs(faqData?.createdAt).format("YYYY-MM-DD HH:mm")}
                </div>
              </div>
            </div>
          </div>
          <div className="flex items-center">
            <div className="w-1/2">
              <div className="flex w-full">
                <div className="text-[12px] border border-r-0 text-black border-primary-grey bg-input-grey p-2 w-[150px]">
                  상태
                </div>
                <div className="p-2 border grow">
                  {" "}
                  {faqData?.status === "OFF" ? "미등록" : "등록"}
                </div>
              </div>
            </div>
            <div className="w-1/2">
              <div className="flex w-full">
                <div className="text-[12px] border border-r-0 text-black border-primary-grey bg-input-grey p-2 w-[150px]">
                  조회수
                </div>
                <div className="p-2 border grow">{faqData?.hitLog}</div>
              </div>
            </div>
          </div>
          <div className="flex items-center">
            <div className="w-full">
              <div className="flex w-full">
                <div className="text-[12px] border border-r-0 text-black border-primary-grey bg-input-grey p-2 w-[150px]">
                  제목
                </div>
                <div className="p-2 border grow">{faqData?.title}</div>
              </div>
            </div>
          </div>
          <div className="flex items-center">
            <div className="w-full">
              <div className="flex w-full">
                <div className="text-[12px] border border-r-0 text-black border-primary-grey bg-input-grey p-2 w-[150px]">
                  내용{" "}
                </div>
                <div className="p-2 border flex-wrap items-center p-2 gap-4 grow w-0">
                  <EditorViewer
                    delta={JSON.parse(faqData?.contents)}
                    className="min-h-[300px] overflow-auto"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-4 flex justify-end">
          <Button width="w-24" onClick={handleBack} text="목록" />

          <Modal
            maxWidth="max-w-[27rem]"
            description={
              <span>
                해당 게시글을 삭제하시겠습니까? <br />
                삭제할 경우, 데이터 복구가 불가능하오니 신중한 선택을 해주시기
                바랍니다.
              </span>
            }
            onSubmit={onDeleteEvent}
          >
            <Button width="w-24" text="삭제" />
          </Modal>
          <Button onClick={handleEdit} primary width="w-24" text="수정" />
        </div>
      </div>
    </>
  );
};

export default FAQDetailPage;
